const LOCAL_STORAGE_WISHLIST_KEY = 'shopify-wishlist';
const LOCAL_STORAGE_DELIMITER = ',';
//localStorage.setItem(LOCAL_STORAGE_WISHLIST_KEY, '');

const getWishlist = () => {
  const wishlist = localStorage.getItem(LOCAL_STORAGE_WISHLIST_KEY) || false;
  
  if (wishlist) {
    //window.history.pushState( {} , '', `?wishlistItems=${wishlist}` );
    return wishlist.split(LOCAL_STORAGE_DELIMITER);
  }
  return [];
};

const setWishlist = (array) => {
  const wishlist = array.join(LOCAL_STORAGE_DELIMITER);
  if (array.length) localStorage.setItem(LOCAL_STORAGE_WISHLIST_KEY, wishlist);
  else localStorage.removeItem(LOCAL_STORAGE_WISHLIST_KEY);
  return wishlist;
};

const updateWishlist = (handle) => {
  const wishlist = getWishlist();
  const indexInWishlist = wishlist.indexOf(handle);
  if (indexInWishlist === -1) wishlist.push(handle);
  else wishlist.splice(indexInWishlist, 1);
  return setWishlist(wishlist);
};

const checkProductExists = (index, handle) => {
  var wishlist = getWishlist();
  var indexInWishlist;
  $.ajax({
    type: "GET",
    async: true,
    url: `/products/${handle}.js`,
    success: function (data) {
      populateWishlist(index, data);
    },
    error: function (xhr, ajaxOptions, thrownError) {
      //removeFromWishlist(handle);
      indexInWishlist = wishlist.indexOf(handle);
      wishlist.splice(indexInWishlist, 1);
      
    },
    dataType: "json"
  });
  return setWishlist(wishlist);
};

const removeFromWishlist = (handle) => {
  const wishlist = getWishlist();
  const indexInWishlist = wishlist.indexOf(handle);
  //var updateWishlistRemoved = wishlist.slice(indexInWishlist, 1);
  var updateWishlistRemoved = wishlist.slice(wishlist.indexOf(handle), 1);
  
  //return setWishlist(wishlist);
};

const wishlistContains = (handle) => {
  const wishlist = getWishlist();
  return wishlist.includes(handle);
};

function displayWishlistItems() {
  var wishlist = getWishlist();
  var toolTipText = '', wishlistLinkClass = '';
  $(".updateWishlist").each(function() {
    var $currentButton = $(this);
    var $heartIcon = $currentButton.find(".fa-solid.fa-heart");
    var currentHandle = $currentButton.attr("data-product-handle");
    var currentTitle = $currentButton.attr("data-product-title");
    if($.inArray(currentHandle, wishlist) !== -1) {
      $heartIcon.addClass("added");
      toolTipText = `Remove <b>${currentTitle}</b> from your wishlist`;
      wishlistLinkClass = 'inWishlistTrue';
    }
    else {
      $heartIcon.removeClass("added");
      toolTipText = `Add <b>${currentTitle}</b> to your wishlist`;
    }
    $currentButton.find(".tooltiptext-Item").html(toolTipText);
    $currentButton.find(".wishlistProduct").addClass(wishlistLinkClass);
  })
}

var wishlistAllowed;
function check_cookie_name(name) {
  var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  match == null ? wishlistAllowed = false : wishlistAllowed = true;
}

$(document).ready(function() {
  check_cookie_name('cookieconsent_status');
  if (!wishlistAllowed) {
    $('.updateWishlist').hide();
    
    $('#wishlistContainer').remove();
  }
  else if (wishlistAllowed) {
    displayWishlistItems();
    $('#wishlistContainer').show();
    $('#wishlistCount_Desktop').text(getWishlist().length);
  }
  
  if (pageHandle != "wishlist") {
    $(document).on('click', '.updateWishlist', function() {
      var $currentButton = $(this);
      var $heartIcon = $currentButton.find(".fa-solid.fa-heart");
      var currentHandle = $currentButton.attr("data-product-handle");
      var currentTitle = $currentButton.attr("data-product-title");
      if ($heartIcon.hasClass("added")) {
        toolTipText = `Remove <b>${currentTitle}</b> from your wishlist`;
      }
      else if (!$heartIcon.hasClass("added")) {
        toolTipText = `Add <b>${currentTitle}</b> to your wishlist`;
      }
      $heartIcon.toggleClass("added");
      //$(this).toggleClass("inWishlistTrue");
      $(this).find(".tooltiptext-Product").html(toolTipText);
      displayWishlistItems();
      $('#wishlistCount_Desktop').text(getWishlist().length);
    });
  }
});